import styled from 'styled-components'

export const StyledFacebookMessageConfirmOrderEdit = styled.div`
  width: 100%;
  margin-bottom: 24px;
  .facebook-message-confirm-edit{
    &_title{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &_content{
      display: flex;
      align-items: center;
      gap: 4px;
      width: fit-content;
      margin-top: 24px;
    }
  }
`
